import { InjectionToken } from "@angular/core";
import { CommissionPayablesPort } from "./commission-payables.port";

export const COMMISSION_PAYABLES_PORT =
  new InjectionToken<CommissionPayablesPort>("COMMISSION_PAYABLES_PORT");
